import { makeAutoObservable } from "mobx";

export interface ImgAndPromptItemType {
  album_name: string;
  album_image_id: number;
  album_id: number;
  is_album: boolean;
  opus_id: number;
  image_id: number;
  image_url: string;
  meta_json: string;
  opus_title: string;
  opus_describes?: string;
  user: {
    nickname: string;
    avatar: string;
    user_id: string;
    is_follow: boolean;
  };
  likes?: number;
  is_like?: boolean;
  is_open?: boolean;
  is_favorites?: boolean;
  status?: 0 | 1 | 2 | 3 | 4; // 0 作品正常  1 举报下架  2 待审核  3 审核未通过  4 用户删除
}
export interface GalleryItemType {
  meta_json: string;
  album_name: string;
  album_image_id: number;
  album_id: number;
  is_album: boolean;
  original: string;
  image_id: number;
  image_url: string;
  width: number;
  height: number;
  user: {
    avatar: string;
    nickname: string;
    user_id: string;
    is_follow?: boolean;
  };
  likes?: number;
  is_like?: boolean;
}
export interface GalleryDataType {
  list: GalleryItemType[];
  counter: number;
  page_size: number;
  page_index: number;
  sort: string;
  author: string;
}
class GalleryStore {
  imgAndPromptList: ImgAndPromptItemType[] = [];
  galleryData: GalleryDataType = {
    list: [],
    counter: 0,
    page_size: 90,
    page_index: 1,
    sort: "sort_default",
    author: "author_all",
  };
  pageLoading = false;
  empty = false;
  wordCheckState = false;
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setImgAndPromptList(imgAndPromptList: ImgAndPromptItemType[]) {
    this.imgAndPromptList = imgAndPromptList;
  }
  setGalleryData(payload: GalleryDataType) {
    this.galleryData = payload;
  }
  setPageLoading(payload: boolean) {
    this.pageLoading = payload;
  }
  setEmpty(payload: boolean) {
    this.empty = payload;
  }
  setWordCheckState(payload: boolean) {
    this.wordCheckState = payload;
  }
}

export const galleryStore = new GalleryStore();
